import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Guid } from 'guid-typescript';
import { configuration } from 'src/environments/environment';
import { PatientBannerService } from '../patient-banner/patient-banner.service';
import { AESAlgorithm } from '../Utilities/Crypto/AESAlgorithm';

@Component({
  selector: 'app-dialerpad-div',
  templateUrl: './dialerpad-div.component.html',
  styleUrls: ['./dialerpad-div.component.css']
})
export class DialerpadDivComponent implements OnInit {
  restoredownVideodiv = false;
  maximizeVideodiv = true;
  closeCall = false;
  public qna_private_url;

  public messageClasses: string = "restoredown";
  linkurl: any;
  twillio: string;
  patPhoneNo: string;
  constructor(private bannerService: PatientBannerService, private sanitizer: DomSanitizer,
    private crypto: AESAlgorithm,
    private _datePipe: DatePipe,) { }

  ngOnInit() {
    this.bannerService.DialerPadShow.subscribe(Pnumber => {
      var splitPhone = Pnumber.split('^');
      this.patPhoneNo = splitPhone[0];
      this.twillio = splitPhone[1];
      this.closeCall = true;
      this.linkurl = "";
      let guid: any = "320050b3-f45c-43dd-8f96-fe1617fe2d32";
      let CurrentDate = this._datePipe.transform(new Date(), "MM/dd/yyyy hh:mm").toString();
      var encDiledString = "";

      var encDiledString = "PatPhoneNum=" + this.patPhoneNo + "&CalDate=" + CurrentDate + "&AuthKey=" + guid;
      let encDialedUrl = this.crypto.urlParmeterEncoder(encDiledString);
      //let serviceLink = 'http://localhost:3000/index.html?';
      //let serviceLink = 'http://vigibossradwlinu.in:3000/index.html?';
      var urllink = configuration.TeleVoiceURL + encDialedUrl;
      this.linkurl = this.sanitizer.bypassSecurityTrustResourceUrl(urllink);
    }, 1000);
  }

  minimizeVideo() {
    this.messageClasses = 'minimize';
    this.restoredownVideodiv = true;
    this.maximizeVideodiv = false;
  }

  restoredownVideo() {
    this.restoredownVideodiv = false;
    this.maximizeVideodiv = true;
    this.messageClasses = 'restoredown';
  }

  maximizeVideo() {
    this.restoredownVideodiv = true;
    this.maximizeVideodiv = false;
    this.messageClasses = 'maximize';
  }

  closeVideoFun() {
    //alert('Are you sure you want to close this video? ')
    let text = "Are you sure you want to close this voice call?";
    if (window.confirm(text) == true) {
      this.closeCall = false;
      this.linkurl = null;
    }
  }
}
